import { NgModule } from '@angular/core';
import { CommonModule } from 'common';
import { AccountSetupRoutingModule } from './account-setup-routing.module';
import { AccountSetupBeginComponent } from './account-setup-begin/account-setup-begin.component';
import { SetupBeginComponent } from './setup-begin/setup-begin.component';
import { VerifyIdentityComponent } from './verify-identity/verify-identity.component';
import { KbaFormContentComponent } from './verify-identity/kba-form-content/kba-form-content.component';
import { IdentityVerificationModule as IdentityVerificationCommonModule } from "common";
import { VerifyIdentityResultComponent } from './verify-identity-result/verify-identity-result.component';
import { IdVerseCompletedCallbackComponent } from './id-verse-completed-callback/id-verse-completed-callback.component';

@NgModule({
  imports: [
    CommonModule,
    AccountSetupRoutingModule,
    IdentityVerificationCommonModule
  ],
  declarations: [
    AccountSetupBeginComponent, 
    SetupBeginComponent,
    VerifyIdentityComponent,
    KbaFormContentComponent,
    VerifyIdentityResultComponent,
    IdVerseCompletedCallbackComponent,
  ]
})
export class AccountSetupModule { }
